/**
 * Rounds half away from zero at two decimal places, returned as a number
 * (not a formatted string) so callers can sum already-rounded line values
 * before formatting a total.
 *
 * A naive `Math.round(value * 100) / 100` (or `value.toFixed(2)`) silently
 * under-reports a cent for inputs that land exactly on a half-cent boundary
 * in decimal but are stored slightly below that boundary in binary floating
 * point -- e.g. `1.005` is actually `~1.00499999999999989...`, so
 * `Math.round(1.005 * 100)` is `100`, not `101`, and `(1.005).toFixed(2)` is
 * `"1.00"`. Nudging the scaled value by a magnitude-proportional
 * `Number.EPSILON` before rounding corrects exactly this class of error
 * without disturbing genuinely-non-boundary values.
 *
 * Single source of truth for this rounding rule. Used by `packages/documents`
 * (order document `Suma netto`/line rounding, via `format-money.ts`) and
 * `apps/web` (client offer review "Suma netto" summary stat and its per-unit
 * price display), so a displayed price and the value it's summed as can
 * never silently diverge -- the exact bug class this helper exists to close.
 */
export function roundMoney(value: number): number {
  const factor = 100;
  const abs = Math.abs(value);
  const roundedAbs = Math.round(abs * factor + Number.EPSILON * abs * factor) / factor;
  return value < 0 ? -roundedAbs : roundedAbs;
}
